// @flow
import React, { useContext } from 'react';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { SecondaryTopBar } from '@components/breadcrumbs/SecondaryTopBar';
import { getWorkloadBreadcrumbs } from '@streaming-projects/utils';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { ClusterLinkingWorkloadContext } from '@streaming-projects/workloads/cluster-linking-workloads/contexts/ClusterLinkingWorkloadContext';

export const SPClusterLinkingWorkloadBreadcrumbs = () => {
  const spOrgData = useContext(SPOrgContext);
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  const workloadData = useContext(ClusterLinkingWorkloadContext);
  const workloadName = workloadData?.name;
  return (
    <SecondaryTopBar
      sectionsToShow={getWorkloadBreadcrumbs(
        spOrgData,
        spStreamingProjectData,
        workloadName,
        'Cluster Linking'
      )}
      showLastUpdatedMessage={false}
    />
  );
};
